export default "__VITE_ASSET__BU5iSd5R__"